import { Adapter as r, getAdapter as e } from "../../adapter.js";
import { GoogleAnalyticsAdapter as p } from "./google/google.adapter.js";
import { FacebookAnalyticsAdapter as i } from "./facebook/facebook.adapter.js";
import { AnalyticsModel as l } from "./analytics.model.js";
class s extends r {
  adapt(o) {
    return new l({
      google: o != null && o.google ? e(p).adapt(o.google) : void 0,
      facebook: o != null && o.facebook ? e(i).adapt(o.facebook) : void 0
    });
  }
  serialize(o) {
  }
}
export {
  s as AnalyticsAdapter
};
//# sourceMappingURL=analytics.adapter.js.map
